// extracted by mini-css-extract-plugin
export var chip = "_rf-2";
export var chipBody = "_rf-8";
export var chipHeader = "_rf-9";
export var chipWithKind = "_rf-7";
export var icon = "_rf-3";
export var kind = "_rf-a";
export var remove = "_rf-5";
export var removeIcon = "_rf-6";
export var row = "_rf-0";
export var rowHistorical = "_rf-1";
export var text = "_rf-4";